import '../scss/catalog-vn-view.scss';
import 'lazysizes';
import 'picturefill';
import 'lightgallery';
import "pickadate/lib/picker.js";
import "pickadate/lib/picker.date.js";
import "pickadate/lib/picker.time.js";
import "pickadate/lib/translations/fr_FR.js";
import 'lg-thumbnail';
import 'lg-fullscreen';
import 'lg-video';
import 'lg-autoplay';

import form from './modules/form';
import * as FormValidation from "formvalidation";
import Bootstrap from "formvalidation/dist/es6/plugins/Bootstrap";


$(document).ready(function() {
    form();
    $('#catalogVnGallery').lightGallery();
    $('.rdv-datepicker').pickadate({
        selectYears: false,
        min: '+3 days',
        disable: [new Date(), 7],
        format: 'dd/mm/yyyy',
        formatSubmit: 'yyyy-mm-dd'
    });

    $('#rdv-hour .rdv-hour').on('click', function(e) {
        e.preventDefault();

        if ($(this).hasClass('active')) {
            $('#rdv-hour .rdv-hour').removeClass('active');
            var HourData = '';
        } else {
            $('#rdv-hour .rdv-hour').removeClass('active');
            $(this).addClass('active');
            var HourData = $(this).data('hour');
        }

        $('#rdv-hour input[type=hidden]').val(HourData);
    });

    $('#test-drive-cta').on('click', function (e) {
        e.preventDefault();
        var nodeToScrollId = '';
        if (window.matchMedia("(min-width: 768px)").matches ) {
            nodeToScrollId = '#catalog-view-block-details--test-drive';
            $(nodeToScrollId).click();
        } else {
            nodeToScrollId = '#paneA-inner';
            if ($(nodeToScrollId).hasClass('collapsed')) {
                $(nodeToScrollId).click();
            }
        }

        $('html, body').animate({
            scrollTop: $(nodeToScrollId).offset().top-10
        }, 800);
    })

    $('#info-cta').on('click', function (e) {
        e.preventDefault();
        var nodeToScrollId = '';
        if (window.matchMedia("(min-width: 768px)").matches ) {
            nodeToScrollId = '#catalog-view-block-details--infos';
            $(nodeToScrollId).click();
        } else {
            nodeToScrollId = '#paneB-inner';
            if ($(nodeToScrollId).hasClass('collapsed')) {
                $(nodeToScrollId).click();
            }
        }

        $('html, body').animate({
            scrollTop: $(nodeToScrollId).offset().top-10
        }, 800);
    })

    $('.catalog-view-block-details .card-header a').on('click', function (e) {
        $(this).find('i').toggleClass('icon-minus-circle icon-plus-circle');
    });

    /* FORM VALIDATION */
    //essai
    const formTestDrive = document.getElementById('form-test-drive');
    if (formTestDrive !== null) {
        const fieldsTestDrive = {
            'vn_test_drive[lead][gender]': {
                validators: {
                    notEmpty: {
                        message: "Civilité obligatoire."
                    },
                }
            },
            'vn_test_drive[lead][lastname]': {
                validators: {
                    notEmpty: {
                        message: "Nom obligatoire."
                    },
                    stringLength: {
                        max: 80,
                        message: 'Maximum de 80 caractères.'
                    },
                }
            },
            'vn_test_drive[lead][firstname]': {
                validators: {
                    notEmpty: {
                        message: "Prénom obligatoire."
                    },
                    stringLength: {
                        max: 80,
                        message: 'Maximum de 80 caractères.'
                    },
                }
            },
            'vn_test_drive[lead][phone]': {
                validators: {
                    notEmpty: {
                        message: "Le téléphone est obligatoire."
                    },
                    stringLength: {
                        max: 10,
                        min: 10,
                        message: 'Le téléphone doit contenir 10 caractères.'
                    },
                }
            },
            'vn_test_drive[lead][email]': {
                validators: {
                    notEmpty: {
                        message: "L'adresse email est obligatoire."
                    },
                    emailAddress: {
                        message: "N'est pas une adresse mail valide."
                    }
                }
            },
            'vn_test_drive[isProfessional]': {
                validators: {
                    notEmpty: {
                        message: "Ce champ est requis."
                    },
                }
            },
            'vn_test_drive[date]': {
                validators: {
                    notEmpty: {
                        message: "Date obligatoire."
                    },
                }
            },
            'vn_test_drive[message]': {
                validators: {
                    notEmpty: {
                        message: "Message obligatoire."
                    },
                }
            },
            'vn_test_drive[energy]': {
                validators: {
                    notEmpty: {
                        message: "Motoristaion obligatoire."
                    },
                }
            },
        };

        FormValidation.formValidation(formTestDrive, {
            fields: fieldsTestDrive,
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new Bootstrap(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                /*icon: new FormValidation.plugins.Icon({
                    valid: 'fa fa-check',
                    invalid: 'fa fa-times',
                    validating: 'fa fa-refresh'
                }),*/ //Avec Bootstrap 4, ne pas oublier d'importer une fontIcons
                // declarative
                declarative: new FormValidation.plugins.Declarative({html5Input: true})
            }
        });
    }

    //contact
    const formContact = document.getElementById('form-contact');
    if (formContact !== null) {
        const fieldsContact = {
            'vn_lead[lead][gender]': {
                validators: {
                    notEmpty: {
                        message: "Civilité obligatoire."
                    },
                }
            },
            'vn_lead[lead][lastname]': {
                validators: {
                    notEmpty: {
                        message: "Nom obligatoire."
                    },
                    stringLength: {
                        max: 80,
                        message: 'Maximum de 80 caractères.'
                    },
                }
            },
            'vn_lead[lead][firstname]': {
                validators: {
                    notEmpty: {
                        message: "Prénom obligatoire."
                    },
                    stringLength: {
                        max: 80,
                        message: 'Maximum de 80 caractères.'
                    },
                }
            },
            'vn_lead[lead][phone]': {
                validators: {
                    notEmpty: {
                        message: "Le téléphone est obligatoire."
                    },
                    stringLength: {
                        max: 10,
                        min: 10,
                        message: 'Le téléphone doit contenir 10 caractères.'
                    },
                }
            },
            'vn_lead[lead][email]': {
                validators: {
                    notEmpty: {
                        message: "L'adresse email est obligatoire."
                    },
                    emailAddress: {
                        message: "N'est pas une adresse mail valide."
                    }
                }
            },
            'vn_lead[isProfessional]': {
                validators: {
                    notEmpty: {
                        message: "Ce champ est requis."
                    },
                }
            },
            'vn_lead[message]': {
                validators: {
                    notEmpty: {
                        message: "Message obligatoire."
                    },
                }
            },
            'vn_lead[energy]': {
                validators: {
                    notEmpty: {
                        message: "Motoristaion obligatoire."
                    },
                }
            },
        };
        FormValidation.formValidation(formContact, {
            fields: fieldsContact,
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new Bootstrap(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                /*icon: new FormValidation.plugins.Icon({
                    valid: 'fa fa-check',
                    invalid: 'fa fa-times',
                    validating: 'fa fa-refresh'
                }),*/ //Avec Bootstrap 4, ne pas oublier d'importer une fontIcons
                // declarative
                declarative: new FormValidation.plugins.Declarative({html5Input: true})
            }
        });
    }





});


// WEBPACK FOOTER //
// ./app/Resources/assets/group/js/catalog-vn-view.js